// components/LineChart.js
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

interface TwoLineChartProps {
  data: any;
  options: any;
}

const TwoLineChart = ({ data, options }: TwoLineChartProps) => {
  return (
    <div className="line-chart h-[95%] w-full">
      <Line data={data} options={options} />
    </div>
  );
};

export default TwoLineChart;
